module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-4.f299fee7.png";